<template>
  <section>
    <b-field grouped>
      <b-input
        v-model="search"
        rounded
        placeholder="Cerca..."
        icon="search"
        @input="delayedUpdate()"
      />
      <b-select
        v-if="filters.length > 0"
        v-model="filtering"
        @input="
          page = 1
          fetch()
        "
      >
        <option value="">Tutti</option>
        <option v-for="filter in filters" :key="filter[0]" :value="filter[0]">
          {{ filter[1] }}
        </option>
      </b-select>
      <b-select
        v-if="hasProvinces"
        v-model="extraParams.province"
        @input="
          page = 1
          fetch()
        "
      >
        <option :value="null">Provincia</option>
        <option
          v-for="province in provinces"
          :key="province[0]"
          :value="province[0]"
        >
          {{ province[1] }}
        </option>
      </b-select>
      <b-select
        v-model="pageSize"
        @input="
          page = 1
          fetch()
        "
      >
        <option value="30">30 per pagina</option>
        <option value="50">50 per pagina</option>
        <option value="100">100 per pagina</option>
        <option value="500">500 per pagina</option>
        <option value="1000">1000 per pagina</option>
        <option value="5000">5000 per pagina</option>
        <option value="10000">1000 per pagina</option>
      </b-select>
    </b-field>

    <b-loading is-full-page :active.sync="loading"></b-loading>

    <b-table
      v-if="items.results"
      v-bind="$attrs"
      paginated
      striped
      backend-pagination
      :data="items.results"
      :total="items.count"
      :per-page="pageSize"
      backend-sorting
      :default-sort="['id', 'desc']"
      :current-page.sync="page"
      v-on="$listeners"
      @page-change="onPageChange"
      @sort="onSort"
    >
      <!-- Pass on all named slots -->
      <slot v-for="slot in Object.keys($slots)" :slot="slot" :name="slot" />

      <!-- Pass on all scoped slots -->
      <template
        v-for="slot in Object.keys($scopedSlots)"
        :slot="slot"
        slot-scope="scope"
      >
        <slot :name="slot" v-bind="scope" />
      </template>

      <template slot="bottom-left">
        <download-csv
          class="button is-default"
          :data="items.results"
          name="data.csv"
          delimiter=";"
        >
          <b-icon icon="table"></b-icon>
          <span>CSV</span>
        </download-csv>
      </template>
    </b-table>
  </section>
</template>

<script>
import debounce from "lodash/debounce"
import provinces from "@/provinces"

export default {
  props: {
    fetchAction: {
      type: Function,
      required: true
    },
    itemsGetter: {
      type: Function,
      required: true
    },
    filters: {
      type: Array,
      default: () => []
    },
    hasProvinces: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: true,
      page: 1,
      pageSize: 30,
      sortField: "id",
      sortOrder: "desc",
      provinces,
      total: 0,
      search: "",
      filtering: "",
      extraParams: {}
    }
  },
  computed: {
    items() {
      if (this.loading) {
        return []
      }
      return this.itemsGetter()
    }
  },
  async mounted() {
    await this.fetch()
  },
  methods: {
    async fetch() {
      this.loading = true
      let params = {
        page: this.page,
        page_size: this.pageSize,
        ordering: `${this.sortOrder == "desc" ? "-" : ""}${this.sortField}`,
        search: encodeURIComponent(this.search),
        filtering: this.filtering,
        ...this.extraParams
      }

      await this.fetchAction(params)
      this.loading = false
    },
    delayedUpdate: debounce(function() {
      this.page = 1
      this.fetch()
    }, 500),
    onPageChange(page) {
      this.page = page
      this.fetch()
    },
    onSort(field, order) {
      this.sortField = field
      this.sortOrder = order
      this.fetch()
    }
  }
}
</script>
